/* global axios */
import ApiClient from './ApiClient';

class VoipCallsAPI extends ApiClient {
  constructor() {
    super('voip_calls', { accountScoped: true });
  }

  urlFor(conversationId) {
    return `${this.baseUrl()}/conversations/${conversationId}/voip_calls`;
  }

  create(conversationId, payload = {}) {
    return axios.post(this.urlFor(conversationId), { voip_call: payload });
  }

  reject({ waha_call_id, from_phone, session_name }) {
    return axios.post(`${this.url}/reject`, {
      waha_call_id,
      from_phone,
      session_name,
    });
  }

  acceptedBroadcast(wahaCallId) {
    return axios.post(`${this.url}/accepted`, { waha_call_id: wahaCallId });
  }

  accept(callRecordId) {
    return axios.post(`${this.url}/accept`, {
      provider: 'stackzap',
      call_record_id: callRecordId,
    });
  }

  rejectStackZap(callRecordId) {
    return axios.post(`${this.url}/reject`, {
      provider: 'stackzap',
      call_record_id: callRecordId,
    });
  }

  hangup(callRecordId) {
    return axios.post(`${this.url}/hangup`, {
      provider: 'stackzap',
      call_record_id: callRecordId,
    });
  }
}

export default new VoipCallsAPI();
